module.exports = __webpack_public_path__ + "static/media/logo_NaDuvida_logo_310x70.4ed58170.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_NaDuvida_logo_310x70.png
// module id = 625
// module chunks = 0